$(document).on('click', '.js-accordion-toggle', function(e) {
  var $accordion = $(this).parents('.js-accordion-row');

  var shown = $accordion.hasClass('active');
  if ( shown ) {
    $accordion.removeClass('active');
  } else {
    $accordion.addClass('active');
  }
});
